/**
 * @deprecated use KitModalV2 instead
 */
// @ts-ignore
export { default as default } from './KitModal';
